const AboutTrbd = () => {
    return (
        <section className="py-20 md:py-32 relative" dir="rtl" id="about">
            <div className="container mx-auto px-6 relative">
                <div className="max-w-3xl mx-auto text-center">
                    {/* Top gradient divider */}
                    <div
                        aria-hidden
                        className="mx-auto mb-10 h-px w-40 opacity-70"
                        style={{
                            background:
                                "linear-gradient(90deg, transparent, hsl(260 90% 65%), hsl(190 90% 50%), transparent)",
                        }}
                    />

                    {/* Eyebrow */}
                    <p className="font-v2-label text-xs text-primary/80 mb-6">عن TRBD</p>

                    {/* Pull-headline — first sentence of the passage */}
                    <h2 className="font-v2-display text-3xl md:text-5xl lg:text-6xl text-white leading-[1.15] mb-10">
                        سبع سنوات مرّت كأنها{" "}
                        <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                            موسم واحد
                        </span>
                    </h2>

                    {/* Body passage */}
                    <p className="text-lg md:text-xl text-white/80 leading-[2] font-medium">
                        بدأنا بمكتب صغير، وفنجان قهوة، وفكرة أكبر من إمكانياتنا: أن الكود الذي
                        يُكتب في دمشق يمكن أن يصل إلى العالم دون أن يفقد رائحته. اليوم، مشاريعنا
                        في أكثر من مئة مدينة، لكن الذي لم يتغيّر أننا ما زلنا نراجع كل سطر كأنه
                        الأول، ونعامل كل عميل كأنه الوحيد.
                    </p>

                    {/* Closing line — pulled out for emphasis */}
                    <p className="mt-10 font-v2-display text-xl md:text-2xl text-white leading-relaxed">
                        لا نبيع خدمات،{" "}
                        <span className="bg-gradient-to-r from-primary to-secondary bg-clip-text text-transparent">
                            نبني ثقة
                        </span>
                        … والثقة لا تُستعجل.
                    </p>

                    {/* Bottom gradient divider */}
                    <div
                        aria-hidden
                        className="mx-auto mt-12 h-px w-40 opacity-70"
                        style={{
                            background:
                                "linear-gradient(90deg, transparent, hsl(190 90% 50%), hsl(260 90% 65%), transparent)",
                        }}
                    />
                </div>
            </div>
        </section>
    );
};

export default AboutTrbd;
